"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");

var rdf_string_1 = require("rdf-string");

var sparqlee_1 = require("sparqlee");

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var GroupsState_1 = require("./GroupsState");
/**
 * A comunica Group Query Operation Actor.
 */


var ActorQueryOperationGroup =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationGroup, _bus_query_operation_);

  function ActorQueryOperationGroup(args) {
    _classCallCheck(this, ActorQueryOperationGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationGroup).call(this, args, 'group'));
  }

  _createClass(ActorQueryOperationGroup, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        var i, _;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (i in pattern.aggregates) {
                  // Will throw for unsupported expressions
                  _ = new sparqlee_1.SyncEvaluator(pattern.aggregates[i].expression);
                }

                return _context.abrupt("return", true);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var input, aggregates, outputRaw, output, variables, sparqleeConfig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Get result stream for the input query
                input = pattern.input, aggregates = pattern.aggregates;
                _context2.next = 3;
                return this.mediatorQueryOperation.mediate({
                  operation: input,
                  context: context
                });

              case 3:
                outputRaw = _context2.sent;
                output = bus_query_operation_1.ActorQueryOperation.getSafeBindings(outputRaw); // The variables in scope are the variables on which we group, i.e. pattern.variables.
                // For 'GROUP BY ?x, ?z', this is [?x, ?z], for 'GROUP by expr(?x) as ?e' this is [?e].
                // But also in scope are the variables defined by the aggregations, since GROUP has to handle this.

                variables = pattern.variables.map(rdf_string_1.termToString).concat(aggregates.map(function (agg) {
                  return rdf_string_1.termToString(agg.variable);
                }));
                sparqleeConfig = Object.assign({}, bus_query_operation_1.ActorQueryOperation.getExpressionContext(context)); // Return a new promise that completes when the stream has ended or when
                // an error occurs

                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var groups = new GroupsState_1.GroupsState(pattern, sparqleeConfig); // Phase 2: Collect aggregator results
                  // We can only return when the binding stream ends, when that happens
                  // we return the identified groups. Which are nothing more than Bindings
                  // of the grouping variables merged with the aggregate variables

                  output.bindingsStream.on('end', function () {
                    try {
                      var bindingsStream = new asynciterator_1.ArrayIterator(groups.collectResults());
                      var metadata = output.metadata;
                      resolve({
                        type: 'bindings',
                        bindingsStream: bindingsStream,
                        metadata: metadata,
                        variables: variables
                      });
                    } catch (err) {
                      reject(err);
                    }
                  }); // Make sure to propagate any errors in the binding stream

                  output.bindingsStream.on('error', reject); // Phase 1: Consume the stream, identify the groups and populate the aggregators.
                  // We need to bind this after the 'error' and 'end' listeners to avoid the
                  // stream having ended before those listeners are bound.

                  output.bindingsStream.on('data', function (bindings) {
                    try {
                      groups.consumeBindings(bindings);
                    } catch (err) {
                      reject(err);
                    }
                  });
                }));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationGroup;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationGroup = ActorQueryOperationGroup;